export default class ProductDescription {
  constructor(component) {
    this.dom = {
      $component: component,
      $tabs: component.querySelectorAll('.js-productDescriptionButton')
    }
    this.state = {
      activeSection: 'description',
      activeSectionClass: 'activeSection'
    }
    this.tabClickHandler = this.tabClick.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$tabs.forEach($tab => $tab.addEventListener('click', this.tabClickHandler))
  }

  tabClick(e) {
    const {dom, state} = this
    const section = e.currentTarget.dataset.section

    if (state.activeSection === section) return

    const currentActiveButton = dom.$component.querySelector(`.js-productDescriptionButton[data-section="${state.activeSection}"]`)
    const currentActiveSection = dom.$component.querySelector(`.js-productDescriptionInfo[data-section="${state.activeSection}"]`)
    const activeButton = e.currentTarget
    const activeSection = dom.$component.querySelector(`.js-productDescriptionInfo[data-section="${section}"]`)

    currentActiveButton.setAttribute('aria-expanded', 'false')
    currentActiveButton.classList.remove(state.activeSectionClass)
    currentActiveSection.classList.remove(state.activeSectionClass)
    activeButton.setAttribute('aria-expanded', 'true')
    activeButton.classList.add(state.activeSectionClass)
    activeSection.classList.add(state.activeSectionClass)
    state.activeSection = section
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductDescription = this
  }
}
